import {
  CreateOrderDto,
  DesignInstanceDto,
  InstanceLogoSpecDto,
  OrderProductDto,
} from "../../../core/models/dtos/CreateOrderDto";
import {
  CartItem,
  CartItemLogo,
  CartItemDesign,
} from "../../../presentation/screens/order-create/models/CartItem";
import { transformStringCase } from "../../../presentation/shared/functions/casing";

export function mapToCreateOrder(orderlines: CartItem[]): CreateOrderDto {
  const orderProducts = orderlines.flatMap((line) => {
    switch (line.type) {
      case "Logo":
        return mapToProductDetailLogoDto(line as CartItemLogo);
      case "Design":
        return mapToProductDetailDesignDto(line as CartItemDesign);
    }
  });

  return {
    products: orderProducts,
  };
}

function mapToProductDetailLogoDto(orderline: CartItemLogo): OrderProductDto[] {
  // For numbersets, create individual order products for each number with quantity > 0
  if (orderline.baseLogo.logoType === "NumberLogo") {
    const products: OrderProductDto[] = [];
    const deliveryQuantities = orderline.deliveryQuantities || [];
    const storageQuantities = orderline.storageQuantities || [];

    // Create order products for each number (0-9) that has quantity > 0
    for (let i = 0; i <= 9; i++) {
      const numberStr = i.toString();
      const deliveryQty =
        deliveryQuantities.find((q) => q.label === numberStr)?.quantity || 0;
      const storageQty =
        storageQuantities.find((q) => q.label === numberStr)?.quantity || 0;

      if (deliveryQty > 0 || storageQty > 0) {
        products.push({
          productNo: orderline.baseLogo.product?.sku!,
          productType: orderline.type,
          toStorage: storageQty,
          toDelivery: deliveryQty,
          value: numberStr,
          isNumeric: true,
        } as OrderProductDto);
      }
    }

    return products;
  }

  // For regular logos, use the standard approach
  const dto = {
    productNo: orderline.baseLogo.product?.sku!,
    productType: orderline.type,
    toStorage: orderline.toStorage,
    toDelivery: orderline.toDelivery,
    value: orderline.value,
  } as OrderProductDto;

  return [dto];
}

function mapToProductDetailDesignDto(
  orderline: CartItemDesign
): OrderProductDto[] {
  const dto = {
    productNo: orderline.design.product?.mul!,
    productType: orderline.type,
    customerEntersNamesAndNumbers: orderline.customerEntersNamesAndNumbers,
    customerEntersNamesAndNumbersEmail:
      orderline.customerEntersNamesAndNumbersEmail,
    casing: orderline.casing,
    instances: orderline.instances.map((x) => {
      return {
        logos: x.logos.map((l) => {
          return {
            isNumeric: l.logoVariant === "number",
            locationIdentifier: l.locationIdentifier,
            value:
              l.logoVariant === "name"
                ? transformStringCase(l.value.toString(), orderline.casing)
                : l.value,
            logoId: l.logoId,
            deliveryType: l.deliveryType,
          } as InstanceLogoSpecDto;
        }),
        toDelivery: x.toDelivery,
        toStorage: x.toStorage,
        value: x.label,
        size: x.size?.toString(),
      } as DesignInstanceDto;
    }),
  } as OrderProductDto;

  let products = [dto];

  for (let key in orderline.instances) {
    let value = orderline.instances[key];
    const logoDesign = orderline.design.designLogos.find(
      (logo) => logo.id === Number(key)
    )!;
    if (logoDesign === undefined) {
      continue;
    }

    products.push({
      productNo: logoDesign!.logo.product?.sku!,
      productType: "Logo",
      toStorage: value.toStorage,
      toDelivery: value.toDelivery,
      // value:  orderline.value,
      // isNumeric: orderline.isNumeric
    } as OrderProductDto);
  }

  return products;
}
